import { EventBus } from '../../helpers';

type SingleBillInfoFormEvents = {
  formDirtyStateChanged: [isDirty: boolean];
};

class SingleBillInfoFormEventBus extends EventBus<SingleBillInfoFormEvents> {}

export const singleBillInfoFormEventBus = new SingleBillInfoFormEventBus();
